"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserService = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Api = _interopRequireDefault(require("../Api"));
var _excluded = ["token"],
  _excluded2 = ["token"],
  _excluded3 = ["token"],
  _excluded4 = ["token", "condo"],
  _excluded5 = ["token"],
  _excluded6 = ["token", "id"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var UserService = exports.UserService = /*#__PURE__*/(0, _createClass2["default"])(function UserService() {
  (0, _classCallCheck2["default"])(this, UserService);
});
(0, _defineProperty2["default"])(UserService, "getByPhone", function (_ref) {
  var token = _ref.token,
    params = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return _Api["default"].withAuth(token).get('/user/byPhone', {
    params: params
  });
});
(0, _defineProperty2["default"])(UserService, "getByPhoneOrEmail", function (_ref2) {
  var token = _ref2.token,
    params = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return _Api["default"].withAuth(token).get('/user/byPhoneOrEmail', {
    params: params
  });
});
(0, _defineProperty2["default"])(UserService, "createUser", function (_ref3) {
  var token = _ref3.token,
    params = (0, _objectWithoutProperties2["default"])(_ref3, _excluded3);
  return _Api["default"].withAuth(token).post('/user', _objectSpread({}, params));
});
(0, _defineProperty2["default"])(UserService, "getEmployees", function (_ref4) {
  var token = _ref4.token,
    condo = _ref4.condo,
    params = (0, _objectWithoutProperties2["default"])(_ref4, _excluded4);
  return _Api["default"].withAuth(token).get("/user/employees/byCondo/".concat(condo, "/admin"), {
    params: params
  });
});
(0, _defineProperty2["default"])(UserService, "createAdmin", function (_ref5) {
  var token = _ref5.token,
    params = (0, _objectWithoutProperties2["default"])(_ref5, _excluded5);
  return _Api["default"].withAuth(token).post('/user/admin', _objectSpread({}, params));
});
(0, _defineProperty2["default"])(UserService, "editAdmin", function (_ref6) {
  var token = _ref6.token,
    id = _ref6.id,
    params = (0, _objectWithoutProperties2["default"])(_ref6, _excluded6);
  return _Api["default"].withAuth(token).patch("/user/admin/".concat(id), _objectSpread({}, params));
});